import * as React from "react";

const SvgLibrary = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 21 20"
    fill="none"
  >
    <g clip-path="url(#clip0_13050_2740)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 1.89429C3.5 1.342 3.94772 0.894287 4.5 0.894287H9.34198C9.74131 0.894287 10.1024 1.13187 10.2604 1.49861L10.9072 3H15.5C16.5224 3 17.3656 3.76718 17.4854 4.75729C17.495 4.83685 17.5 4.91785 17.5 5V15C17.5 16.1046 16.6046 17 15.5 17H5.5C4.39543 17 3.5 16.1046 3.5 15V5C3.5 4.97387 3.5005 4.94786 3.50149 4.92197H3.5V1.89429ZM0.5 4.75C0.5 4.33579 0.835786 4 1.25 4C1.66421 4 2 4.33579 2 4.75V15.25C2 15.6642 1.66421 16 1.25 16C0.835786 16 0.5 15.6642 0.5 15.25V4.75ZM19 4.75C19 4.33579 19.3358 4 19.75 4C20.1642 4 20.5 4.33579 20.5 4.75V15.25C20.5 15.6642 20.1642 16 19.75 16C19.3358 16 19 15.6642 19 15.25V4.75ZM8.75 12.984C8.75 13.4001 9.22854 13.6341 9.55697 13.3787L12.7426 10.901C12.9999 10.7008 12.9999 10.3119 12.7426 10.1117L9.55697 7.63399C9.22854 7.37855 8.75 7.61259 8.75 8.02867V12.984ZM5 5.5H5.5H15.5H16V15C16 15.2761 15.7761 15.5 15.5 15.5H5.5C5.22386 15.5 5 15.2761 5 15V5.5Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_13050_2740">
        <rect
          width="1em"
          height="1em"
          fill="currentColor"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgLibrary;
